export default __webpack_public_path__ + "static/media/user-avatar-white.ec9321ba.svg";